import React from 'react';
import { Space, Switch, Select, Typography, Tooltip } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

const INTERVAL_OPTIONS = [
  { label: '10s', value: 10_000 },
  { label: '30s', value: 30_000 },
  { label: '1m', value: 60_000 },
  { label: '2m', value: 120_000 },
  { label: '5m', value: 300_000 },
  { label: '10m', value: 600_000 },
];

export interface AutoRefreshToggleProps {
  enabled: boolean;
  onEnabledChange: (enabled: boolean) => void;
  intervalMs: number;
  onIntervalChange: (intervalMs: number) => void;
}

export const AutoRefreshToggle: React.FC<AutoRefreshToggleProps> = ({
  enabled,
  onEnabledChange,
  intervalMs,
  onIntervalChange,
}) => {
  return (
    <Space size={6} align="center">
      <Tooltip
        title={
          enabled
            ? `Auto-refreshing every ${
                INTERVAL_OPTIONS.find((o) => o.value === intervalMs)?.label ?? `${intervalMs}ms`
              }`
            : 'Auto-refresh off'
        }
      >
        <ReloadOutlined
          spin={enabled}
          style={{ color: enabled ? '#1890ff' : undefined, fontSize: 14 }}
        />
      </Tooltip>
      <Text style={{ fontSize: 13 }}>Auto</Text>
      <Switch size="small" checked={enabled} onChange={onEnabledChange} />
      <Select
        size="small"
        value={intervalMs}
        onChange={onIntervalChange}
        disabled={!enabled}
        options={INTERVAL_OPTIONS}
        style={{ width: 70 }}
      />
    </Space>
  );
};
